var path = '/HistoricBuildingForm'

function get (http, id) {
    return http.get(path + `/Get?id=${id}&getComponents=true`)
}
function put (http, rockArtPanelDto) {
    return http.put(path + '?saveComponents=true', rockArtPanelDto)
}
function search (http, searchDto) {
    return http.post(path + '/Search?getComponents=true', searchDto)
}

function getBuildingFunctionList () {
    return [
        {buildingFunctionId: 1, description: 'Residential'},
        {buildingFunctionId: 2, description: 'Commercial'},
        {buildingFunctionId: 3, description: 'Agricultural'},
        {buildingFunctionId: 4, description: 'Industrial'},
        {buildingFunctionId: 5, description: 'Government'},
        {buildingFunctionId: 6, description: 'Educational'},
        {buildingFunctionId: 7, description: 'Religious'},
        {buildingFunctionId: 8, description: 'Other'}
    ]
}

function getBuildingSettingList () {
    return [
        {buildingSettingId: 1, description: 'Residential'},
        {buildingSettingId: 2, description: 'Commercial'},
        {buildingSettingId: 3, description: 'Agricultural'},
        {buildingSettingId: 4, description: 'Industrial'},
        {buildingSettingId: 5, description: 'Government'}
    ]
}

function getBuildingStyleList () {
    return [
        {buildingStyleId: 1, description: 'Art Deco'},
        {buildingStyleId: 2, description: 'Classical Revival'},
        {buildingStyleId: 3, description: 'Colonial Revival'},
        {buildingStyleId: 4, description: 'Craftsman'},
        {buildingStyleId: 5, description: 'Dutch Colonial Revival'},
        {buildingStyleId: 6, description: 'Edwardian'},
        {buildingStyleId: 7, description: 'English-Norman'},
        {buildingStyleId: 8, description: 'Exotic Revival'},
        {buildingStyleId: 9, description: 'Folk Victorian'},
        {buildingStyleId: 10, description: 'Georgian Revival'},
        {buildingStyleId: 11, description: 'Gothic Revival'},
        {buildingStyleId: 12, description: 'International'},
        {buildingStyleId: 13, description: 'Italianate'},
        {buildingStyleId: 14, description: 'Mediterranean'},
        {buildingStyleId: 15, description: 'Mission'},
        {buildingStyleId: 16, description: 'Moderne'},
        {buildingStyleId: 17, description: 'Neoclassical'},
        {buildingStyleId: 18, description: 'Prairie'},
        {buildingStyleId: 19, description: 'Pueblo Revival'},
        {buildingStyleId: 20, description: 'Queen Anne'},
        {buildingStyleId: 28, description: 'Richardsonian Romanesque'},
        {buildingStyleId: 21, description: 'Rustic'},
        {buildingStyleId: 22, description: 'Second Empire'},
        {buildingStyleId: 23, description: 'Shingle'},
        {buildingStyleId: 24, description: 'Spanish Colonial Revival/Spanish Eclectic'},
        {buildingStyleId: 25, description: 'Tudor Revival'},
        {buildingStyleId: 26, description: 'Usonian'},
        {buildingStyleId: 27, description: 'None'},
        { buildingStyleId: 29, description: 'Other' },
        { buildingStyleId: 30, description: 'Unknown' },
        { buildingStyleId: 31, description: 'Not Applicable' }
    ]
}
function getBuildingTypeCategory () {
    return [
        {buildingCategoryId: 1, description: 'Residential'},
        {buildingCategoryId: 2, description: 'Commercial'},
        {buildingCategoryId: 3, description: 'Agricultural'},
        {buildingCategoryId: 4, description: 'Industrial'},
        {buildingCategoryId: 5, description: 'Civic'}
    ]
}
function getBuildingTypeList () {
    return [
        {buildingTypeId: 1, buildingCategoryId: 1, description: 'A-Frame'},
        {buildingTypeId: 2, buildingCategoryId: 1, description: 'Bi-level'},
        {buildingTypeId: 3, buildingCategoryId: 1, description: 'Bungalow'},
        {buildingTypeId: 4, buildingCategoryId: 1, description: 'Foursquare'},
        {buildingTypeId: 5, buildingCategoryId: 1, description: 'I-House'},
        {buildingTypeId: 6, buildingCategoryId: 1, description: 'Minimal Traditional'},
        {buildingTypeId: 7, buildingCategoryId: 1, description: 'Duplex'},
        {buildingTypeId: 8, buildingCategoryId: 1, description: 'Ranch'},
        {buildingTypeId: 9, buildingCategoryId: 1, description: 'Shotgun'},
        {buildingTypeId: 10, buildingCategoryId: 1, description: 'Split-Level'},
        {buildingTypeId: 11, buildingCategoryId: 1, description: 'Saltbox'},
        {buildingTypeId: 12, buildingCategoryId: 1, description: 'Hall and parlor'},
        {buildingTypeId: 13, buildingCategoryId: 1, description: 'Apartment '},
        {buildingTypeId: 14, buildingCategoryId: 1, description: 'Single pen'},
        {buildingTypeId: 15, buildingCategoryId: 1, description: 'Double pen'},
        {buildingTypeId: 16, buildingCategoryId: 1, description: 'Saddlebag'},
        {buildingTypeId: 17, buildingCategoryId: 1, description: 'Triplex'},
        {buildingTypeId: 18, buildingCategoryId: 1, description: 'Dugout'},
        {buildingTypeId: 19, buildingCategoryId: 1, description: 'Basement House'},
        {buildingTypeId: 20, buildingCategoryId: 1, description: 'Mobile Home'},
        {buildingTypeId: 21, buildingCategoryId: 1, description: 'Row House'},
        {buildingTypeId: 22, buildingCategoryId: 1, description: 'Other'},

        {buildingTypeId: 24, buildingCategoryId: 2, description: 'False Front'},
        {buildingTypeId: 25, buildingCategoryId: 2, description: 'Single Retail'},
        {buildingTypeId: 26, buildingCategoryId: 2, description: 'Multi Retail'},
        {buildingTypeId: 27, buildingCategoryId: 2, description: 'Corner Store'},
        {buildingTypeId: 28, buildingCategoryId: 2, description: 'Office Tower'},
        {buildingTypeId: 29, buildingCategoryId: 2, description: 'Strip Mall'},
        {buildingTypeId: 30, buildingCategoryId: 2, description: 'Gas Station - Canopy'},
        {buildingTypeId: 31, buildingCategoryId: 2, description: 'Gas Station - Oblong Box'},
        {buildingTypeId: 32, buildingCategoryId: 2, description: 'Gas Station - Cottage'},
        {buildingTypeId: 33, buildingCategoryId: 2, description: 'Big Box'},
        {buildingTypeId: 34, buildingCategoryId: 2, description: 'Motel/Motor Court'},
        {buildingTypeId: 35, buildingCategoryId: 2, description: 'Hotel'},
        {buildingTypeId: 36, buildingCategoryId: 2, description: 'Other'},

        {buildingTypeId: 37, buildingCategoryId: 3, description: 'Loafing Shed'},
        {buildingTypeId: 38, buildingCategoryId: 3, description: 'Quonset'},
        {buildingTypeId: 39, buildingCategoryId: 3, description: 'Garage'},
        {buildingTypeId: 40, buildingCategoryId: 3, description: 'Barn - Bank'},
        {buildingTypeId: 41, buildingCategoryId: 3, description: 'Barn - Other'},
        {buildingTypeId: 42, buildingCategoryId: 3, description: 'Barn - Arched'},
        {buildingTypeId: 43, buildingCategoryId: 3, description: 'Barn - Transverse'},
        {buildingTypeId: 44, buildingCategoryId: 3, description: 'Barn - English'},
        {buildingTypeId: 45, buildingCategoryId: 3, description: 'Barn - Dairy'},
        {buildingTypeId: 46, buildingCategoryId: 3, description: 'Machine Shed'},
        {buildingTypeId: 47, buildingCategoryId: 3, description: 'Greenhouse'},
        {buildingTypeId: 48, buildingCategoryId: 3, description: 'Garage'},
        {buildingTypeId: 49, buildingCategoryId: 3, description: 'Shed'},
        {buildingTypeId: 50, buildingCategoryId: 3, description: 'Root cellar'},
        {buildingTypeId: 51, buildingCategoryId: 3, description: 'Other'},

        {buildingTypeId: 52, buildingCategoryId: 4, description: 'Mill'},
        {buildingTypeId: 53, buildingCategoryId: 4, description: 'Power Plant/House'},
        {buildingTypeId: 54, buildingCategoryId: 4, description: 'Machine Shop'},
        {buildingTypeId: 55, buildingCategoryId: 4, description: 'Roundhouse'},
        {buildingTypeId: 56, buildingCategoryId: 4, description: 'Warehouse'},
        {buildingTypeId: 57, buildingCategoryId: 4, description: 'Depot'},
        {buildingTypeId: 58, buildingCategoryId: 4, description: 'Factory'},
        {buildingTypeId: 59, buildingCategoryId: 4, description: 'Refinery'},
        {buildingTypeId: 60, buildingCategoryId: 4, description: 'Processing Plant'},
        {buildingTypeId: 61, buildingCategoryId: 4, description: 'Other'},

        {buildingTypeId: 62, buildingCategoryId: 5, description: 'School'},
        {buildingTypeId: 63, buildingCategoryId: 5, description: 'Religious'},
        {buildingTypeId: 64, buildingCategoryId: 5, description: 'Courthouse'},
        {buildingTypeId: 65, buildingCategoryId: 5, description: 'Museum'},
        {buildingTypeId: 66, buildingCategoryId: 5, description: 'Office'},
        {buildingTypeId: 67, buildingCategoryId: 5, description: 'Jail/Prison'},
        {buildingTypeId: 68, buildingCategoryId: 5, description: 'Other'}
    ]
}

function getStoryList () {
    return [
        {storyId: 1, description: '1'},
        {storyId: 2, description: '1.5'},
        {storyId: 3, description: '2'},
        {storyId: 5, description: '2.5'},
        {storyId: 4, description: '3+'}
    ]
}

function getElementList () {
    return [
        {buildingElementId: 1, description: 'Roof'},
        {buildingElementId: 2, description: 'Walls'},
        {buildingElementId: 3, description: 'Foundation'},
        {buildingElementId: 4, description: 'Windows'},
        {buildingElementId: 5, description: 'Doors'},
        {buildingElementId: 6, description: 'Chimneys'},
        {buildingElementId: 7, description: 'Porches'}
    ]
}

function getElementTypeList () {
    return [
        //ROOF
        {elementTypeId: 1, buildingElementId: 1, description: 'Gabled'},
        {elementTypeId: 2, buildingElementId: 1, description: 'Cross-gabled'},
        {elementTypeId: 3, buildingElementId: 1, description: 'Shed'},
        {elementTypeId: 4, buildingElementId: 1, description: 'Hipped'},
        {elementTypeId: 5, buildingElementId: 1, description: 'Cross-hipped'},
        {elementTypeId: 6, buildingElementId: 1, description: 'Flat'},
        {elementTypeId: 7, buildingElementId: 1, description: 'Gambrel'},
        {elementTypeId: 8, buildingElementId: 1, description: 'Mansard'},
        {elementTypeId: 9, buildingElementId: 1, description: 'Pyramidal'},
        {elementTypeId: 10, buildingElementId: 1, description: 'None'},
        //WALLS
        {elementTypeId: 11, buildingElementId: 2, description: 'Frame'},
        {elementTypeId: 12, buildingElementId: 2, description: 'Log'},
        {elementTypeId: 13, buildingElementId: 2, description: 'Masonry'},
        {elementTypeId: 14, buildingElementId: 2, description: 'Earth'},
        {elementTypeId: 15, buildingElementId: 2, description: 'Poured Concrete'},
        {elementTypeId: 43, buildingElementId: 2, description: 'None'},
        //FOUNDATION
        {elementTypeId: 16, buildingElementId: 3, description: 'Pier'},
        {elementTypeId: 17, buildingElementId: 3, description: 'Wall'},
        {elementTypeId: 18, buildingElementId: 3, description: 'Slab'},
        {elementTypeId: 19, buildingElementId: 3, description: 'None'},
        //WINDOWS
        {elementTypeId: 20, buildingElementId: 4, description: 'Fixed'},
        {elementTypeId: 21, buildingElementId: 4, description: 'Double-hung'},
        {elementTypeId: 22, buildingElementId: 4, description: 'Casement'},
        {elementTypeId: 23, buildingElementId: 4, description: 'Sliding'},
        {elementTypeId: 24, buildingElementId: 4, description: 'Hopper'},
        {elementTypeId: 25, buildingElementId: 4, description: 'Awning'},
        {elementTypeId: 26, buildingElementId: 4, description: 'Pivot'},
        {elementTypeId: 27, buildingElementId: 4, description: 'Louver'},
        {elementTypeId: 28, buildingElementId: 4, description: 'None'},
        //DOORS
        {elementTypeId: 29, buildingElementId: 5, description: 'Solid'},
        {elementTypeId: 30, buildingElementId: 5, description: 'Paneled w/ glass'},
        {elementTypeId: 31, buildingElementId: 5, description: 'Paneled'},
        {elementTypeId: 32, buildingElementId: 5, description: 'Batten'},
        {elementTypeId: 33, buildingElementId: 5, description: 'Other'},
        {elementTypeId: 34, buildingElementId: 5, description: 'None'},
        //CHIMNEYS
        {elementTypeId: 35, buildingElementId: 6, description: 'Exterior'},
        {elementTypeId: 36, buildingElementId: 6, description: 'Interior'},
        {elementTypeId: 44, buildingElementId: 6, description: 'None'},
        //PORCHES
        {elementTypeId: 37, buildingElementId: 7, description: 'Stoop'},
        {elementTypeId: 38, buildingElementId: 7, description: 'Portico'},
        {elementTypeId: 39, buildingElementId: 7, description: 'Enclosed'},
        {elementTypeId: 40, buildingElementId: 7, description: 'Full Width'},
        {elementTypeId: 41, buildingElementId: 7, description: 'Warp Around'},
        {elementTypeId: 42, buildingElementId: 7, description: 'Other'},
        {elementTypeId: 45, buildingElementId: 7, description: 'None'},
        //ALL
        { elementTypeId: 998, buildingElementId: null, description: 'Unknown' },
        { elementTypeId: 999, buildingElementId: null, description: 'N/A' }
    ]
}
function getElementMaterialList () {
    return [
        {elementMaterialId: 1, buildingElementId: 1, description: 'Asphalt/Composite'},
        {elementMaterialId: 2, buildingElementId: 1, description: 'Wood'},
        {elementMaterialId: 3, buildingElementId: 1, description: 'Metal'},
        {elementMaterialId: 4, buildingElementId: 1, description: 'Sod'},
        {elementMaterialId: 5, buildingElementId: 1, description: 'Tile'},
        {elementMaterialId: 6, buildingElementId: 1, description: 'Asbestos'},
        {elementMaterialId: 7, buildingElementId: 1, description: 'Other'},

        {elementMaterialId: 8, buildingElementId: 2, description: 'Wood-Log'},
        {elementMaterialId: 9, buildingElementId: 2, description: 'Wood-Board'},
        {elementMaterialId: 10, buildingElementId: 2, description: 'Wood-Shingle'},
        {elementMaterialId: 11, buildingElementId: 2, description: 'Wood-Panel'},
        {elementMaterialId: 12, buildingElementId: 2, description: 'Masonry-Brick'},
        {elementMaterialId: 13, buildingElementId: 2, description: 'Masonry-Stone'},
        {elementMaterialId: 14, buildingElementId: 2, description: 'Masonry-Concrete Block'},
        {elementMaterialId: 15, buildingElementId: 2, description: 'Stucco'},
        {elementMaterialId: 16, buildingElementId: 2, description: 'Asbestos'},
        {elementMaterialId: 17, buildingElementId: 2, description: 'Metal'},
        {elementMaterialId: 18, buildingElementId: 2, description: 'Asphalt/Composite'},
        {elementMaterialId: 19, buildingElementId: 2, description: 'Vinyl'},
        {elementMaterialId: 20, buildingElementId: 2, description: 'Other'},

        {elementMaterialId: 21, buildingElementId: 3, description: 'Wood'},
        {elementMaterialId: 22, buildingElementId: 3, description: 'Masonry-Brick'},
        {elementMaterialId: 23, buildingElementId: 3, description: 'Masonry-Stone'},
        {elementMaterialId: 24, buildingElementId: 3, description: 'Masonry-Concrete Block'},
        {elementMaterialId: 25, buildingElementId: 3, description: 'Concrete'},
        {elementMaterialId: 26, buildingElementId: 3, description: 'Other'},

        {elementMaterialId: 27, buildingElementId: 4, description: 'Wood'},
        {elementMaterialId: 28, buildingElementId: 4, description: 'Metal'},
        {elementMaterialId: 29, buildingElementId: 4, description: 'Vinyl'},
        {elementMaterialId: 30, buildingElementId: 4, description: 'Wood-clad metal'},
        {elementMaterialId: 31, buildingElementId: 4, description: 'Other'},

        {elementMaterialId: 32, buildingElementId: 5, description: 'Wood'},
        {elementMaterialId: 33, buildingElementId: 5, description: 'Metal'},
        {elementMaterialId: 34, buildingElementId: 5, description: 'Vinyl'},
        {elementMaterialId: 35, buildingElementId: 5, description: 'Other'},

        {elementMaterialId: 36, buildingElementId: 6, description: 'Brick'},
        {elementMaterialId: 37, buildingElementId: 6, description: 'Stone'},
        {elementMaterialId: 38, buildingElementId: 6, description: 'Other'},

        {elementMaterialId: 39, buildingElementId: 7, description: 'Wood-Log'},
        {elementMaterialId: 40, buildingElementId: 7, description: 'Wood-Board'},
        {elementMaterialId: 41, buildingElementId: 7, description: 'Wood-Shingle'},
        {elementMaterialId: 42, buildingElementId: 7, description: 'Wood-Panel'},
        {elementMaterialId: 43, buildingElementId: 7, description: 'Masonry-Brick'},
        {elementMaterialId: 44, buildingElementId: 7, description: 'Masonry-Stone'},
        {elementMaterialId: 45, buildingElementId: 7, description: 'Masonry-Concrete Block'},
        {elementMaterialId: 46, buildingElementId: 7, description: 'Stucco'},
        {elementMaterialId: 47, buildingElementId: 7, description: 'Asbestos'},
        {elementMaterialId: 48, buildingElementId: 7, description: 'Metal'},
        {elementMaterialId: 49, buildingElementId: 7, description: 'Asphalt/Composite'},
        {elementMaterialId: 50, buildingElementId: 7, description: 'Vinyl'},
        {elementMaterialId: 51, buildingElementId: 7, description: 'Other'},

        //ALL
        { elementMaterialId: 998, buildingElementId: null, description: 'Unknown' },
        { elementMaterialId: 999, buildingElementId: null, description: 'N/A' }
    ]
}
function getBuildingIntegrityList () {
    return [
        {buildingIntegrityId: 1, description: 'Excellent'},
        {buildingIntegrityId: 2, description: 'Good'},
        {buildingIntegrityId: 3, description: 'Fair'},
        {buildingIntegrityId: 4, description: 'Poor'}
    ]
}
function getBuildingConditionList () {
    return [
        {buildingConditionId: 1, description: 'Excellent'},
        {buildingConditionId: 2, description: 'Good'},
        {buildingConditionId: 3, description: 'Fair'},
        {buildingConditionId: 4, description: 'Poor'},
        {buildingConditionId: 5, description: 'Ruins'},
        {buildingConditionId: 6, description: 'Demolished'}
    ]
}
function getConstructionDateTypes () {
    return [
        {constructionDateTypeId: 1, description: 'Construction Date'},
        {constructionDateTypeId: 2, description: 'Moved Date'},
        {constructionDateTypeId: 3, description: 'Altered Date'}
    ]
}

function getPriorityList () {
    return [
        {surveyPriorityId: 1, description: 'High'},
        {surveyPriorityId: 2, description: 'Medium'},
        {surveyPriorityId: 3, description: 'Low'}
    ]
}

export default {
    get: get,
    put: put,
    search: search,

    getBuildingFunctionList: getBuildingFunctionList,
    getBuildingSettingList: getBuildingSettingList,
    getBuildingStyleList: getBuildingStyleList,
    getBuildingTypeList: getBuildingTypeList,
    getBuildingTypeCategory: getBuildingTypeCategory,
    getStoryList: getStoryList,
    getElementList: getElementList,
    getElementTypeList: getElementTypeList,
    getElementMaterialList: getElementMaterialList,
    getBuildingIntegrityList: getBuildingIntegrityList,
    getBuildingConditionList: getBuildingConditionList,
    getConstructionDateTypes: getConstructionDateTypes,
    getPriorityList: getPriorityList
}



// WEBPACK FOOTER //
// ./src/services/siteForm/historicBuildingService.js